export default __webpack_public_path__ + "static/jcbaey-b96a092fd859458e7d843e59e9235b70.jpg";